<div class="iframe-container" [ngStyle]="getContainerStyles()">
	<!-- checkbox controls the menu state -->
  <input id="menuToggle" class="menu-toggle" type="checkbox" />

  <!-- the visible hamburger (label toggles the checkbox) -->
  <!-- hidden checkbox -->
  <input type="checkbox" id="menu-toggle" class="menu-toggle">

  <!-- hamburger icon -->
  <label for="menu-toggle" class="hamburger">
    <span></span>
    <span></span>
    <span></span>
  </label>

  <!-- slide-out menu -->
  <nav class="menu">
    <div class="iframe-controls">
		<div class="component-selector">
		<label for="componentSelect">Select Component to Test:</label>
		<select id="componentSelect" [(ngModel)]="selectedComponent" (change)="onComponentChange()">
			<option *ngFor="let component of availableComponents" [value]="component.value">
			{{component.label}}
			</option>
		</select>
		</div>
		
		<div class="size-controls">
			<h4>Container Size</h4>
			
			<div class="size-input-group">
				<label for="widthInput">Width:</label>
				<div class="input-with-unit">
					<input 
						id="widthInput"
						type="number" 
						[(ngModel)]="widthValue" 
						(ngModelChange)="onSizeChange()"
						min="0"
						step="1"
						class="size-input">
					<select [(ngModel)]="widthUnit" (ngModelChange)="onWidthUnitChange()" class="unit-select">
						<option *ngFor="let unit of availableUnits" [value]="unit">{{unit}}</option>
					</select>
				</div>
			</div>
			
			<div class="size-input-group">
				<label for="heightInput">Height:</label>
				<div class="input-with-unit">
					<input 
						id="heightInput"
						type="number" 
						[(ngModel)]="heightValue" 
						(ngModelChange)="onSizeChange()"
						min="0"
						step="1"
						class="size-input">
					<select [(ngModel)]="heightUnit" (ngModelChange)="onHeightUnitChange()" class="unit-select">
						<option *ngFor="let unit of availableUnits" [value]="unit">{{unit}}</option>
					</select>
				</div>
			</div>
			
			<div class="size-display">
				<p><strong>Current Size:</strong></p>
				<p>{{containerWidth}} × {{containerHeight}}</p>
			</div>
			
			<button class="reset-button" (click)="resetToFullSize()">Reset to Full Size</button>
		</div>
	</div>
  </nav>

  <!-- overlay (clicking it should close the menu because it's after the checkbox; use label hack) -->
  <!-- Make an overlay label that also toggles the input, so clicking overlay closes the menu -->
  <label for="menuToggle" class="overlay" aria-hidden="true"></label>

  
  
  <div class="iframe-wrapper">
    <iframe 
	  id="iframe-tester"
      class="iframe-tester" 
      [src]="iframeSrc" 
      width="100%" 
      height="800" 
      title="Component Testing Frame"
      frameborder="0">
    </iframe>
  </div>
</div>